import { Reveal } from "./Reveal";

const SITUATIONS = [
    "Momenti di cambiamento",
    "Difficoltà relazionali",
    "Periodi di forte stress",
    "Difficoltà emotive",
    "Senso di smarrimento",
    "Autostima",
    "Regolazione delle emozioni",
    "Comprendere meglio se stessi",
    "Crescita personale",
];

export const QuandoUtile = () => (
    <section id="quando-utile" className="bg-petrol text-cream" data-testid="quando-section">
        <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-20 md:py-32">
            <Reveal className="max-w-3xl mx-auto text-center">
                <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-snug" data-testid="quando-title">
                    A volte qualcosa dentro di noi chiede di essere ascoltato.
                </h2>
                <p className="mt-7 text-base sm:text-lg text-cream/75 leading-relaxed">
                    Non serve attraversare una crisi per rivolgersi a uno psicologo. Ci sono momenti della vita in cui fermarsi e farsi accompagnare può fare la differenza.
                </p>
            </Reveal>

            <div className="mt-14 flex flex-wrap justify-center gap-3 sm:gap-4 max-w-4xl mx-auto">
                {SITUATIONS.map((s, i) => (
                    <Reveal key={s} delay={i * 0.05}>
                        <span
                            className="inline-block rounded-full border border-cream/20 bg-cream/5 px-6 py-3 text-sm sm:text-base text-cream/90 hover:bg-cream/15 hover:border-cream/40 transition-all duration-300 cursor-default"
                            data-testid={`quando-chip-${i}`}
                        >
                            {s}
                        </span>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.2}>
                <p className="mt-14 max-w-2xl mx-auto text-center text-sm text-cream/50 leading-relaxed" data-testid="quando-disclaimer">
                    Questi spunti non costituiscono una diagnosi e non sostituiscono in alcun modo una valutazione professionale. Ogni situazione merita di essere compresa nella sua unicità.
                </p>
            </Reveal>
        </div>
    </section>
);
